import { iconsAdapter } from './icons'
import { goodsAdapter } from './goods'
import { couponsAdapter } from './coupons'
import { floatWindowAdapter } from './float_window'
import { videoAdapter } from './video'
import { seckillAdapter } from './seckill'
export const modulesAdapters = {
  icons: iconsAdapter,
  common_commodity: goodsAdapter,
  mc_goods_group: goodsAdapter,
  mc_billion_goods_group: goodsAdapter,
  coupon: couponsAdapter,
  float_window: floatWindowAdapter,
  video: videoAdapter,
  mc_seckill: seckillAdapter
}
